import { Injectable } from '@angular/core';
import {
  HttpResponse,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize, map, tap } from 'rxjs/operators';
import { CommonService } from '../../../service/common/common.service';

@Injectable({
  providedIn: 'root'
})
export class ApiResponseInterceptor implements HttpInterceptor {

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          //if file is coming as response 
          if (event.body instanceof Blob) {
            const fileName = this.getFileName(event.headers);
            this.downloadFile(event.body, fileName);
            return event;
          }
          else {
            const response = event as HttpResponse<any>;
            const body = response.body;
            if (body) {
              return response.clone({ body: body });
            }
          }
        }
        return event;
      })
      ,
      finalize(()=>{
CommonService.hideLoader();
      })
    );
  }
  //download the file 
  downloadFile(blob: Blob, fileName: string): void {
    const downloadUrl = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = downloadUrl;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(downloadUrl);
  }

  //to get file Name from content Disposition if there is any
  getFileName(headers: any): string {
    const contentDisposition = headers.get('content-disposition');
    if (contentDisposition) {
      const fileNameMatch = contentDisposition.match(/filename\s*=\s*"?([^"]*)"?/);
      const fileName = fileNameMatch ? fileNameMatch[1].trim() : null;
      return fileName || 'download';
    }
    return 'Attachement';
  }
}
